/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
const JunitTestLogBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['stdout', codecString],
    ['stderr', codecString],
    ['exitCode', codecNumber, 'exit_code'],
    ['timeSpend', parsers.duration, 'time_spend'],
]), AutoTestStepLogBase);
export class JunitTestLogBase extends AutoTestStepLogBase {
    static decode(input) {
        return JunitTestLogBaseParser.decode(input).map(res => new JunitTestLogBase(res));
    }
    static unsafeDecode(input) {
        return JunitTestLogBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestLogBaseParser.encode(data);
    }
    static schema() {
        return JunitTestLogBaseParser.schema();
    }
}
